import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Form } from 'react-bootstrap';
const NotesTab = ({ onFieldChange, formData, errors }) => {
    return (_jsx("div", { className: 'row', children: _jsx("div", { className: 'col-md-8 mt-4', children: _jsxs(Form.Group, { children: [_jsx(Form.Label, { className: 'notes-h6', children: "Notities" }), _jsx(Form.Control, { as: 'textarea', name: 'note', className: 'vn-Input notes-textarea', value: formData.note ?? '', onChange: (e) => onFieldChange('note', e.target.value), rows: 8, placeholder: 'Typ hier uw tekst' })] }) }) }));
};
export default NotesTab;
